import { render, staticRenderFns } from "./ServiceProvidersTab.vue?vue&type=template&id=b4a1068c&"
import script from "./ServiceProvidersTab.vue?vue&type=script&lang=js&"
export * from "./ServiceProvidersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports